

import backgroundImage from '../../../../Assets/Backgrounds/mountain.svg';

import { makeStyles } from 'tss-react/mui';
import EDBox from '../../../../BaseComponents/EDBox/EDBox';
import { Environment } from '../../../../Utils/Logger';

interface IProps {
  hideEnvironment?: boolean;
}

const useStyles = makeStyles()(
  theme =>
    ({
      container: {
        position: 'relative',
        display: 'flex',
        width: '100%',
        padding: '4px',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'url("' + backgroundImage + '")',
        backgroundPosition: 'bottom center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundSize: '100%',
        backgroundColor: theme.customProperties.backgroundImageColor,
        boxSizing: 'border-box',
        height: '100%',
      },
    } as const)
);

/**
Bakgrundsbild som visas bakom inloggningsformuläret om man inte är inloggad (inloggningsformuläret kan också visas ovanför en aktuell session om den bara är låst)
*/
const NoSessionBackground: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <EDBox
        sx={theme => ({
          position: 'absolute',
          bottom: theme.spacing(1),
          right: theme.spacing(1),
          color: 'common.white',
        })}
      >
        {window.env.environment !== Environment.production &&
        !props.hideEnvironment
          ? window.env.environment
          : ''}
      </EDBox>
    </div>
  );
};

export default NoSessionBackground;
